import React, { SVGProps } from 'react';

const DefaultBooleanIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.41667 2.5H14.1667C15.7775 2.5 17.0833 3.80583 17.0833 5.41667V5.41667C17.0833 7.0275 15.7775 8.33333 14.1667 8.33333H5.41667C3.80583 8.33333 2.5 7.0275 2.5 5.41667V5.41667C2.5 3.80583 3.80583 2.5 5.41667 2.5Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.1667 17.5H5.41667C3.80583 17.5 2.5 16.1942 2.5 14.5834V14.5834C2.5 12.9725 3.80583 11.6667 5.41667 11.6667H14.1667C15.7775 11.6667 17.0833 12.9725 17.0833 14.5834V14.5834C17.0833 16.1942 15.7775 17.5 14.1667 17.5Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.165 14.1667C13.935 14.1667 13.7483 14.3534 13.75 14.5834C13.75 14.8134 13.9367 15 14.1667 15C14.3967 15 14.5833 14.8134 14.5833 14.5834C14.5833 14.3534 14.3967 14.1667 14.165 14.1667"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M5.41501 5C5.18501 5 4.99834 5.18667 5.00001 5.41667C5.00001 5.64667 5.18668 5.83333 5.41668 5.83333C5.64668 5.83333 5.83334 5.64667 5.83334 5.41667C5.83334 5.18667 5.64668 5 5.41501 5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default DefaultBooleanIcon;
